import * as React from 'react'
import styles from './style.module.css';
import Button from '../../../design-system/lib/Button';
import { Attach, AUTO_DISPATCH, calendar_gray, calendar_time_gray, CLOSE, COD, double_top, email_icon, hashtag2, INFO_CIRCLE, input, list_gray, MAP, notes } from '../../../assets';
import DropDown from '../../../design-system/lib/DropDown';
import Modal from '../../../design-system/lib/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Service_Option, ChangeNewTravelDialoge, NewOrder_Order_setCustomField, NewTravelResetReserve, New_Order_Reset_DropOff, New_Order_Reset_DropOffs, New_Order_Reset_Pickup, New_Travel_PaymentMethod, Remove_Service_Option, ResetNewOrder, SetCodAmount, SetNotesOrder, SetReferenceID, Set_Auto_ActiveVehicleType, Set_DropOff_Inputs, Set_NewOrder_OrderType, Set_Pickup_address, Set_Service_ActiveVehicleType, Set_Service_DeliveryMethod, Set_newOrder_draft } from '../../../Redux/actions/actionNames';
import { getCenterMap } from '../../../helper/module';
import { GetVehicletypeByServiceAction } from '../../../Redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Input from '../../../design-system/lib/Input';
import { Link } from 'react-router-dom';
import history from '../../../service/history';
import Typography from '../../../design-system/lib/Typography';
import { LearnMore } from '../../learnMore';
import { UseCRUDDropoffs } from '../../../hooks/useCRUD_Dropoffs';
import Radiobutton from '../../../design-system/lib/Radiobutton';
import CustomField_DropDown from '../../../CustomFields/DropDown';
import Toggle from '../../../design-system/lib/toggle';
import CustomField_Input from '../../../CustomFields/Input';
import TooltipOnro from '../../../design-system/lib/Tooltip';
import CustomField_Phone from '../../../CustomFields/phone';
import CustomField_MultiLine from '../../../CustomFields/multiLine';
import CustomField_Date from '../../../CustomFields/Date';
import CustomField_DateTime from '../../../CustomFields/DateTime';
import CustomField_file from '../../../CustomFields/file';
import CustomField_json from '../../../CustomFields/json';
import jalali from "jalali-moment";
import { checkTimestamp, get_dateFormat, get_lang } from '../../../helper/UserData/userdate';
import EllipisWithTooltip from '../../../design-system/lib/ellipsis-with-tooltip';
import { isEmpty } from 'lodash';
import clsx from 'clsx';
import Checkbox from '../../../design-system/lib/Checkbox';


let hardcodecustomfield = [
  {
    "id": "ord_single",
    "key": "order_title",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Title",
    "isRequired": true,
    "config": {
      "type": "singleLine",
      "minLength": 3,
      "maxLength": 50,
      "pattern": "^[A-Za-z0-9 ]+$"
    }
  },
  {
    "id": "ord_multi",
    "key": "order_description",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Description",
    "isRequired": false,
    "config": {
      "type": "multiLine",
      "minLength": 10,
      "maxLength": 300
    }
  },
  {
    "id": "ord_phone",
    "key": "contact_phone",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Contact Phone",
    "isRequired": true,
    "config": {
      "type": "phone",
      "unique": true
    }
  },
  {
    "id": "ord_email",
    "key": "contact_email",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Contact Email",
    "isRequired": false,
    "config": {
      "type": "email",
      "unique": false
    }
  },
  {
    "id": "ord_number",
    "key": "order_number",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Number",
    "isRequired": true,
    "config": {
      "type": "number",
      "unique": true,
      "min": 1,
      "max": 999999
    }
  },
  {
    "id": "ord_decimal",
    "key": "order_price",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Price",
    "isRequired": true,
    "config": {
      "type": "decimalNumber",
      "precision": 2,
      "min": 0,
      "max": 100000
    }
  },
  {
    "id": "ord_bool",
    "key": "order_has_insurance",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Has Insurance?",
    "isRequired": false,
    "config": {
      "type": "boolean"
    }
  },
  {
    "id": "ord_date",
    "key": "preferred_date",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Preferred Date",
    "isRequired": false,
    "config": {
      "type": "date"
    }
  },
  {
    "id": "ord_datetime",
    "key": "preferred_datetime",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Preferred DateTime",
    "isRequired": false,
    "config": {
      "type": "dateTime"
    }
  },
  {
    "id": "ord_select",
    "key": "order_type",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Order Type",
    "isRequired": true,
    "config": {
      "type": "select",
      "choices": [
        { "key": "normal", "label": "Normal" },
        { "key": "express", "label": "Express" }
      ]
    }
  },
  {
    "id": "ord_file",
    "key": "order_attachment",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Attachment",
    "isRequired": false,
    "config": {
      "type": "file",
      "maxSizeMB": 10,
      "allowedTypes": [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "text/plain"
      ]
    }
  },
  {
    "id": "ord_json",
    "key": "extra_metadata",
    "entityType": "order",
    "stage": "orderCreation",
    "label": "Extra Metadata",
    "isRequired": false,
    "config": {
      "type": "json"
    }
  }
]



function ServiceNewOrder() {
  const [dialoge, setDialoge] = React.useState(null);
  const [collapsed, setCollapsed] = React.useState(true);

  const [canshowbooleanContainers, setCanshowbooleanContainers] = React.useState(true);

  const mapRef = useSelector((state) => state.Map.mapRef)
  const center = useSelector((state) => state.Map.center)
  const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const serviceOrderTypes = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType ? state.NewOrder.newOrder.service.activeVehicleType.orderTypes : [])
  const options = useSelector((state) => state.NewOrder.newOrder.service.options)
  const serviceVehicleTypes = useSelector((state) => state.SharedData.services)
  const lang = useSelector((state) => state.LocalData.lang)
  const paymentMethod = useSelector((state) => state.NewOrder.newOrder.paymentMethod.paymentMethod)
  const paymentSide = useSelector((state) => state.NewOrder.newOrder.paymentMethod.paymentSide)
  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const activeDeliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)
  let { items, sEtItems } = UseCRUDDropoffs()
  const intercomData = useSelector((state) => state.SharedData.settings?.intercomData)
  const draft = useSelector((state) => state.NewOrder.newOrder.draft)
  const REFREV = useSelector((state) => state.NewOrder.newOrder.referenceID)
  const notess = useSelector((state) => state.NewOrder.newOrder.notes)
  const customField = useSelector((state) => state.NewOrder.newOrder.customField)
  const CODV = useSelector((state) => state.NewOrder.newOrder.codAmount)


  function hasCustomFieldError(fieldKey, definitions, customField, t) {
    const field = definitions.find(f => f.key === fieldKey);
    if (!field) return false;

    const value = customField[field.key];
    const config = field.config;

    const isEmptyx =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    if (!field.isRequired && isEmptyx) return false;

    if (field.isRequired && isEmptyx) {
      return false
    }

    // TEXT
    if (config.type === "singleLine" || config.type === "multiLine") {
      if (typeof value !== "string") {
        return t("custominvalid");
      }

      if (config.minLength && value.length < config.minLength ) {
        return t("customminLength", { min: config.minLength });
      }

      if (config.maxLength && value.length > config.maxLength) {
        return t("custommaxLength", { max: config.maxLength });
      }

      if (config.pattern && !new RegExp(config.pattern).test(value)) {
        return t("custompattern");
      }
    }

    // EMAIL
    if (config.type === "email") {
      if (!/^\S+@\S+\.\S+$/.test(value)) {
        return t("customemail");
      }
    }

    // PHONE
    if (config.type === "phone") {
      if (value.toString().length < 7) {
        return t("customphone");
      }
    }

    // NUMBER
    if (config.type === "number") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });
      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }
    }

    // DECIMAL


    if (config.type === "decimalNumber") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });

      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }

      if (config.precision !== undefined) {
        const decimals = value.toString().split(".")[1];
        if (decimals && decimals.length > config.precision) {
          return t("customdecimalPrecision", { p: config.precision });
        }
      }
    }



    // SELECT
    if (config.type === "select") {
      const allowed = config.choices.map(c => c.key);
      if (!allowed.includes(value)) {
        return t("customselect");
      }
    }

    // FILE
    if (config.type === "file") {

      if (value.url) {

      } else {
        if (!(value instanceof File)) {
          return t("customfileInvalid");
        }

        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          return t("customfileSize", { max: config.maxSizeMB });
        }

        if (
          config.allowedTypes?.length &&
          !config.allowedTypes.includes(value.type)
        ) {
          return t("customfileType");
        }
      }

    }

    // DATE
    if (config.type === "date" || config.type === "dateTime") {
      if (isNaN(new Date(value).getTime())) {
        return t("customdate");
      }
    }

    return false;
  }



  function renderCustomField(
    field,
    value,
    filterdcustomFieldDefinitions
  ) {
    switch (field.config.type) {
      case 'phone':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Phone   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} hint={field?.label} inputType="number" onChange={(e) => {

              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))

            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );

      case 'singleLine':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );
      case 'email':

        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} config={field.config} icon={email_icon} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );


      case 'number':
      case 'decimalNumber':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} config={field.config} icon={hashtag2} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );

      case 'multiLine':
        return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_MultiLine   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e?.target.value }))

            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );

      case 'boolean':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ 
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}>
              <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} 
                 {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
              </span>
            <Toggle isActive={customField[field.key] || false} setIsHover={(e) => {
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: !(customField[field.key] || false) }))

            }} />
          </div>
        );

      case 'select':
        return (

          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}>
              <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} 
                   {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
                </span>
            <CustomField_DropDown   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  icon={list_gray}
              ItemsList={ItemsList(field?.config?.choices.map((item) => { return { title: item.label, data: item, id: item.key } }), customField[field.key], (JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO.id }))


              })} textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? customField[field.key] : field?.label} placement={'bottomStart'}
              data={field?.config?.choices} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: null }))
              }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>

        );

      case 'date':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Date icon={calendar_gray}
              textStyle={styles.DropDownTextStyle} size='Small'
              text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${get_dateFormat()}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")} onChange={(JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO }))


              }}
              isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 


          </div>
        );

      case 'dateTime':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row",
              justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_DateTime icon={calendar_time_gray}
              textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(customField[field.key]))}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")}
              onChange={(JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO }))


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 


          </div>

        );

      case 'file':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip>
            </span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_file   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  config={field.config} icon={Attach} inputType={"file"}
              textStyle={styles.DropDownTextStyle} size='Small' text={field?.label} placement={'bottomStart'}
              requiredText={t("Required")} onChange={(JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO }))


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 


          </div>
        );


      default:
        return null;
    }
  }




  const checkSelectedPaymnetMethod = (service) => {
    if (paymentSide + paymentMethod == "SenderCash") {
      if (!service.setting.isCashBySenderActive) {
        dispatch(
          New_Travel_PaymentMethod({
            paymentSide: "Sender",
            paymentMethod: "Wallet",
          })
        );
      }
    } else if (paymentSide + paymentMethod == "ReceiverCash") {
      if (!service.setting.enableReceiverCash) {
        dispatch(
          New_Travel_PaymentMethod({
            paymentSide: "Sender",
            paymentMethod: "Wallet",
          })
        );
      }
    }

  }


  const handleOrderType = (type) => {
    dispatch(Set_NewOrder_OrderType(type.data))
    if (type.data == "Pickup") {
      dispatch(New_Order_Reset_DropOffs())
      dispatch(New_Order_Reset_DropOff())

    } else if (type.data == "Delivery") {
      dispatch(New_Order_Reset_Pickup())
      dispatch(New_Order_Reset_DropOffs())

    } else if (type.data == "PickupDelivery") {
      dispatch(New_Order_Reset_DropOffs())
    }
  }



  const handleServiceService = (service) => {

    dispatch(NewTravelResetReserve())

    dispatch(Set_Service_ActiveVehicleType(service))
    if (activeDeliveryMethod && activeDeliveryMethod.dropoffLocationType !== service.deliveryMethods[0]?.dropoffLocationType) {
      items.forEach((ddd, i) => {
        dispatch(
          Set_DropOff_Inputs({
            name: "address",
            value: "",
            firstDropOff: i == 0,
            id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "idx",
            value: null,
            firstDropOff: i == 0,
            id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "name",
            value: null,
            firstDropOff: i == 0,
            id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "adresss_loc",
            value: { lng: "", lat: "" },
            firstDropOff: i == 0,
            id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
          })
        );
      })
    }

    if (activeDeliveryMethod && activeDeliveryMethod.pickupLocationType !== service.deliveryMethods[0].pickupLocationType) {
      dispatch(
        Set_Pickup_address({
          address: "",
          adresss_loc: { lng: "", lat: "" },
          placeId: "",
          idx: null,
          name: null
        })
      );
    }
    dispatch(Set_Service_DeliveryMethod(service.deliveryMethods[0]))

    if (orderTypeActive) {
      if (service.orderTypes.indexOf(orderTypeActive) == -1) {
        handleOrderType({ data: service.orderTypes[0] })
      }
    } else {
      handleOrderType({ data: service.orderTypes[0] })
    }


    checkSelectedPaymnetMethod(service)
    let center = getCenterMap(mapRef)

    dispatch(GetVehicletypeByServiceAction(dispatch, {
      latitude: center.lat,
      longitude: center.lng,

      serviceId: service.id
    }, (vt) => {

      if (vt) {
        dispatch(Set_Auto_ActiveVehicleType(vt[0]));
      }

    }))



  }

  React.useEffect(() => {
    if (serviceVehicleTypes.length > 0 && !activeVehicleType) {
      handleServiceService(serviceVehicleTypes[0])
    }
  }, [activeVehicleType, serviceVehicleTypes])

  React.useEffect(() => {
    if (!orderTypeActive) {
      if (serviceOrderTypes.length > 0) {
        handleOrderType({ data: serviceOrderTypes[0] })
      }
    }
  }, [orderTypeActive])



    React.useEffect(() => {
      setCanshowbooleanContainers(false)
      setTimeout(() => {
         setCanshowbooleanContainers(true)
      }, 100);
     
  }, [activeVehicleType])

  
 

    const booleanHandleactive = React.useCallback((OP) => {
    if (booleanOptionisSaved(OP)) {
      dispatch(Remove_Service_Option(OP.id))
    } else {
      dispatch(Add_Service_Option({
        id: OP.id,
        type: "boolean"
      }))
    }

  }, [options]);


    const booleanOptionisSaved = React.useCallback((OP) => {

     let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }


  }, [options]);


  const ListhandleSelectedItem = (OP, item) => {

    if (ListoptionisSaved(item)) {
      dispatch(Remove_Service_Option(item.id))
      dispatch(Add_Service_Option({
        name: item.name,
        id: item.id,
        item: OP,
        type: "list"
      }))
    } else {
      dispatch(Add_Service_Option({
        name: item.name,
        id: item.id,
        item: OP,
        type: "list"
      }))
    }


  };


  const ListoptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }

  const ListoptionText = (option) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === option.id;
    });
    if (booll) {
      return `${booll.item.title}`
    } else {
      return t("Select")
    }
  }


  const inputHandleactive = (OP) => {
    // if (inputOptionisSaved(OP) && String(e.target.value).trim().length == 0) {
    //   dispatch(Remove_Service_Option(OP.id))
    // } else {
    //   dispatch(Add_Service_Option({
    //     id:OP.id,
    //     inputValue:OP.inputValue,
    //     type:OP.type,
    //     update:inputOptionisSaved(OP)
    //   }))
    // }
    if (OP.inputValue) {
      dispatch(Add_Service_Option({
        id: OP.id,
        inputValue: OP.inputValue,
        type: OP.type,
        update: inputOptionisSaved(OP)
      }))
    }
  };


  const inputOptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }


  const inputoptionText = (option) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === option.id;
    });
    if (booll) {
      return `${option.title} : ${booll.inputValue}`
    } else {
      return false
    }
  }

  const getInputoptionValue = (option) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === option.id;
    });
    if (booll) {
      return booll.inputValue
    } else {
      return null
    }
  }

  const InputOptionHandle = React.useCallback(() => {

    if (String(dialoge.inputType).length > 0) {
      inputHandleactive(dialoge)
      setTimeout(() => {
        setDialoge(null)
      }, 100);
    }

  }, [dialoge]);


  const showRequirdalert = React.useCallback(() => {

    let xx = false;
    let yy = false;

    try {
      activeVehicleType?.options?.filter((item) => { return item.isRequired }).forEach((itemx) => {

        let booll = false;
        booll = options.find((item) => {
          return item.id === itemx.id;
        });
        if (!booll) {
          xx = true
        }

      })



      activeVehicleType?.orderCustomFieldDefinitions?.filter((item) => { return (item.stage == "orderCreation" && item.isRequired) }).forEach((item) => {
        if (!customField[item.key]) {
          [
            yy = true
          ]
        }
      })

      return (xx || yy)
    } catch (error) {
      return false
    }



  }, [customField, activeVehicleType, options]);

  const closeNewOrder = () => {
    dispatch(ChangeNewTravelDialoge());
    dispatch(ResetNewOrder())

  }


  function ItemsList(data, currentState, setCurrentState) {
    return (
      <div className={styles.itemsConatiner}>
        {data?.map((item) => {
          return <div onClick={() => { setCurrentState(item) }}>
            <Radiobutton size="Small" state={(currentState == item.id || currentState == item.title) ? "checked" : "unchecked"} onClick={() => { }} />
            {item.icon && <img src={item.icon} />}
            <Typography weight={(currentState == item.id || currentState == item.title) ? 'Body_Middle_Bold' : 'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={(currentState == item.id || currentState == item.title) ? styles.dropItemchecked : styles.dropItemUnchecked} />

          </div>
        })}
      </div>
    )
  }


  return (
    <div className={styles.ServiceNewOrderContainer}>


      <div className={styles.ServiceNewOrderSecondRow} style={{ gap: "8px" }}>
        <DropDown size='Small' ItemsList={ItemsList(serviceVehicleTypes, activeVehicleType?.id, handleServiceService)} text={activeVehicleType?.title} icon={activeVehicleType?.icon} className={styles.service} placement='bottomEnd' data={serviceVehicleTypes} onClick={handleServiceService} checkSelected="full" />
        {((activeVehicleType && activeVehicleType.setting.isReferenceIdActive) || (activeVehicleType && activeVehicleType.setting.isCODActive) || (activeVehicleType && activeVehicleType.options.length > 0) || ["PickupDelivery"].indexOf(orderTypeActive) > -1 ||
          (activeVehicleType ? activeVehicleType.orderCustomFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).length > 0 : true)) &&
          <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*' isRequired={showRequirdalert()} onClick={() => { setCollapsed(!collapsed) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />}

      </div>

      {(collapsed && ((activeVehicleType && activeVehicleType.setting.isReferenceIdActive) || (activeVehicleType && activeVehicleType.setting.isCODActive) || (activeVehicleType && activeVehicleType.options.length > 0) || ["PickupDelivery"].indexOf(orderTypeActive) > -1 ||
          (activeVehicleType ? activeVehicleType.orderCustomFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).length > 0 : true))) && <div className={styles.collapsed}>

        {(serviceOrderTypes.length > 1 || orderTypeActive == "PickupDelivery") && <div className={styles.ServiceNewOrderCollapsedRow} >
          {serviceOrderTypes.length > 1 && <DropDown size='tiny' pretitle={t("Order type")} ItemsList={ItemsList(serviceOrderTypes.map((item) => { return { title: t(item), data: item, id: t(item) } }), t(orderTypeActive), handleOrderType)} text={t(orderTypeActive ? ` ${t(orderTypeActive)}` : "PleaseSelect")} placement='bottomEnd' data={serviceOrderTypes.map((item) => { return { title: t(item), data: item } })} onClick={handleOrderType} checkSelected='full' />}
          {orderTypeActive == "PickupDelivery" && <DropDown pretitle={t("status")} ItemsList={ItemsList([{ title: t("statusDraft"), draft: true, id: t("statusDraft") }, { title: t("statusConfirmed"), draft: false, id: t("statusConfirmed") }], draft ? t("statusDraft") : t("statusConfirmed"), (JOJO) => { dispatch(Set_newOrder_draft(JOJO.draft)) })} style={{ with: "calc(100% - 20px)" }} className={styles.DropDown} size='tiny' text={draft ? `${t("statusDraft")}` : `${t("statusConfirmed")}`} placement='bottomEnd' data={[{ title: "Draft", draft: true }, { title: "Confirmed", draft: false }]} isRequired={false} requiredText={t("Required")} onClick={(JOJO) => { dispatch(Set_newOrder_draft(JOJO.draft)) }} isSelected={false} />}
        </div>}

        {(activeVehicleType && activeVehicleType.options.length > 0) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Options")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>}

        {(activeVehicleType && activeVehicleType.options.length > 0) &&



          < >
         {(activeVehicleType.options.filter((item)=>item.type == "boolean").length > 0 && canshowbooleanContainers) && <div className={styles.booleanContainers}>
          
          
            {activeVehicleType.options.filter((item)=>item.type == "boolean").map((item, i) => {
              return  <div className={clsx(styles.OptionsRow , styles.item)}  onClick={() => { booleanHandleactive(item) }}style={{backgroundColor : booleanOptionisSaved(item) && "rgba(16, 128, 255, 0.08)"}} >

                   <Checkbox size='Small' state={booleanOptionisSaved(item) ? 'checked' : "unchecked"} style={{minWidth:"16px !important"}}    onClick={() => { booleanHandleactive(item) }}/> 
                   <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" ,display:"flex" ,flexDirection:"row" }}> <EllipisWithTooltip maxWidth={80}>{item.title}</EllipisWithTooltip> {(item.isRequired && !booleanOptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  {/* <Toggle isActive={booleanOptionisSaved(item)} setIsHover={() => { booleanHandleactive(item) }} /> */}
                  
                </div>
             })}
            </div>}


              {activeVehicleType.options.filter((item)=>item.type != "boolean").map((item, i) => {
              return item.type === "list" ? (

                <div className={styles.OptionsRow}>
                  <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" ,display:"flex" ,flexDirection:"row" }}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip> {(item.isRequired && !ListoptionText(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  <CustomField_DropDown icon={list_gray} ItemsList={ItemsList(item.data.map((item) => { return { ...item, title: item.title, data: item } }), ListoptionisSaved(item) ? ListoptionText(item) : item.title, (JOJO) => ListhandleSelectedItem(JOJO, item))} textStyle={styles.DropDownTextStyle} size='Small' text={ListoptionisSaved(item) ? ListoptionText(item) : t("Select")} placement={i == 0 ? 'bottomStart' : "bottomEnd"} data={item.data} requiredText={t("Required")} onClick={(JOJO) => ListhandleSelectedItem(JOJO, item)} isSelected={ListoptionisSaved(item)} clearText={t("clear")} clearOnClick={() => { ListoptionisSaved(item) && dispatch(Remove_Service_Option(item.id)) }} />
                </div>
              ) : 
                <div className={styles.OptionsRow}>
                  <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",display:"flex" ,flexDirection:"row"  }}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip> {(item.isRequired && !inputOptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  <CustomField_Input defvalue={getInputoptionValue(item)} icon={input} hint={item.hint} inputType={item.inputType} onChange={(e) => {
                    dispatch(Add_Service_Option({
                      id: item.id,
                      inputValue: e,
                      type: item.type,
                      update: inputOptionisSaved(item)
                    }))
                  }} />
                </div> 
             })}

          </ >
        }
        {((activeVehicleType && activeVehicleType.setting.isReferenceIdActive) || (activeVehicleType && activeVehicleType.setting.isCODActive) || ["PickupDelivery"].indexOf(orderTypeActive) > -1) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Fields")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>}

        {(activeVehicleType && activeVehicleType.setting.isReferenceIdActive) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> {t("Ref ID")}

            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
            </TooltipOnro>


          </span>
          <CustomField_Input icon={hashtag2} hint={t("Ref ID")} inputType="text" defvalue={REFREV} onChange={(e) => {
            dispatch(SetReferenceID(e ? e : ""))

          }} />
        </div>}

        {(activeVehicleType && activeVehicleType.setting.isCODActive) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("CashOnDelivery")}   </span>
          <CustomField_Input defvalue={CODV} config={{
            "type": "decimalNumber",
            "precision": 2,
            "min": 0,
            "max": 999999999
          }} icon={COD} hint={t("CashOnDelivery")} inputType="number" onChange={(e) => {
            dispatch(SetCodAmount(e ? e : ""))

          }} />
        </div>}


        {(["PickupDelivery"].indexOf(orderTypeActive) > -1) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("Notes")}


          </span>
          <CustomField_Input icon={notes} hint={t("Notes")} inputType="text" defvalue={notess} onChange={(e) => {
            dispatch(SetNotesOrder(e ? e : ""))

          }} />
        </div>}

        {(activeVehicleType && activeVehicleType.orderCustomFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).length > 0) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>
        }

        {/* {(activeVehicleType && activeVehicleType.orderCustomFieldDefinitions.filter((item) => { 
 
           return item.stage == "orderCreation" }).length > 0) && activeVehicleType.orderCustomFieldDefinitions.filter((item) => { return item.stage == "orderCreation" }).map((item) => {
          return <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("CashOnDelivery")}   </span>
            <CustomField_Input icon={hashtag2} hint={t("CashOnDelivery")} inputType="number" onChange={(e) => {
              dispatch(SetCodAmount(e.target.value ? e.target.value : ""))

            }} />
          </div>
        })
        } */}


        {activeVehicleType?.orderCustomFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).map(field =>
          renderCustomField(field, "", activeVehicleType?.orderCustomFieldDefinitions || [])
        )}


        {/* <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> phone  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Phone value={null} hint="phone" inputType="number" onChange={(e) => {

          }} />
        </div>

         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> singleLine  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 50,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("singleLine")} inputType="text" onChange={(e) => {
 
          }} />
        </div>


         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> email  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("email")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "email"
          }} icon={email_icon} hint={t("singleLine")} inputType="text" onChange={(e) => {

          }} />
        </div>


         <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> multiLine  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_MultiLine config={{
            "type": "multiLine",
            "minLength": 10,
            "maxLength": 300
          }} icon={input} hint={t("multiLine")} inputType="text" onChange={(e) => {
 
          }} />
        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> number  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "number"
          }} icon={input} hint={t("number")} inputType="number" onChange={(e) => {
 
          }} />
        </div>

 
 

        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>decimalNumber</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "decimalNumber",
            "precision": 2,
            "min": 0,
            "max": 100000
          }} icon={input} hint={t("decimalNumber")} inputType="number" onChange={(e) => {
             console.log("CustomField_Phone ",e)

          }} />
        </div>



 

        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> boolean {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
          <Toggle isActive={false} setIsHover={() => { }} />
        </div>



 

        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> select {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
          <CustomField_DropDown icon={list_gray} ItemsList={ItemsList([{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }].map((item) => { return { title: item.label, data: item, id: item.key } }), "key3", (JOJO) => { })} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} data={[{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }]} requiredText={t("Required")} onClick={(JOJO) => {
            
          }} isSelected={false} clearText={t("clear")} clearOnClick={() => { }} />
        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>date</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Date icon={calendar_gray} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'}  requiredText={t("Required")} onChange={(JOJO ) => {
 
          }} isSelected={false} clearText={t("clear")} clearOnClick={() => { }} />

        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>dateTime</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_DateTime icon={calendar_time_gray}  textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} requiredText={t("Required")} onChange={(JOJO) => { 
 
          }} isSelected={false} clearText={t("clear")} clearOnClick={() => { }} />

        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>file</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_file config={{
            "type": "file",
            "maxSizeMB": 10,
            "allowedTypes": [
              "application/pdf",
              "image/jpeg",
              "image/png",
              "text/plain"
            ]
          }} icon={Attach} inputType={"file"} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'}  requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={true} clearText={t("clear")} onChange={(JOJO) => {
                                                 console.log("CustomField_Phone ",JOJO)

           }} />

        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>json</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_json hint={"hint"} icon={input} inputType={"text"} ItemsList={ItemsList([{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }].map((item) => { return { title: item.label, data: item, id: item.key } }), "key3", (JOJO) => { })} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} data={[{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }]} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={true} clearText={t("clear")} clearOnClick={() => { }} />

        </div> */}


      </div>}


      {/* <Modal size='Small' icon={AUTO_DISPATCH} title='Customer can’t choose this service' description='You shoud choose another customer or choose another service which this customer can choose ' CancelText='Skip' ConfirmationText='OK'/> */}

      {dialoge && <Modal ConfirmationOnClick={InputOptionHandle} onclose={() => { setDialoge(null) }} size='large' icon={CLOSE} title={dialoge.title} body={<div> <Input type={dialoge.inputType} placeHolder={dialoge.hint} value={dialoge.inputValue} onChange={(e) => {
        setDialoge({
          ...dialoge,
          inputValue: e.target.value
        })
      }} /> </div>} ConfirmationText={t("Savechanges")} footer={<><Button size={'Medium'} style={{ marginInlineEnd: "16px" }} type='Secondary' text={t("clear")} onClick={() => {
        dispatch(Remove_Service_Option(dialoge.id))
        setDialoge(null)
      }} /></>} />}

    </div>
  )
}

export default ServiceNewOrder